/**
 * useSmbMatricaCampaign Hook
 *
 * Fetches and manages SMB Matrica campaign status.
 * Returns campaign details including:
 * - Whether campaign is active
 * - User's bonus points earned
 * - Remaining bonus available
 * - Campaign dates
 * - Whether user is verified as SMB holder via Matrica
 */

import { useQuery } from '@tanstack/react-query';

import { getSmbMatricaCampaignStatus } from '@/api/auth';
import config from '@/config';

export function useSmbMatricaCampaign() {
  const query = useQuery({
    queryKey: ['smbMatricaCampaign'],
    queryFn: async () => {
      const response = await getSmbMatricaCampaignStatus();
      if (response.code !== 0) {
        throw new Error(response.message || 'Failed to fetch campaign status');
      }
      return response.data;
    },
    enabled: config.ENABLE_SMB_MATRICA_CAMPAIGN, // Only fetch if feature flag is enabled
    staleTime: 15 * 60 * 1000, // Cache for 15 minutes
    refetchInterval: 30 * 60 * 1000, // Refetch every 30 minutes (eligibility rarely changes mid-session)
  });

  return {
    campaignData: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
